import React from 'react';
import { Route, Routes } from 'react-router';
import { PagePath } from '../navigation.enums';
import { ErrorRedirect } from './routers.helpers';
import { YourAssessmentsPage } from '../../pages/your-assessments/your-assessments.page';
import { YourAssessmentPage } from '../../pages/your-assessments/your-assessment.page';

export function YourAssessmentsRouter(): JSX.Element {
  return (
    <Routes>
      <Route path={PagePath.root} element={<YourAssessmentsPage />} />
      <Route path={PagePath.yourAssessmentsAssessment} element={<YourAssessmentPage />} />

      <Route path={PagePath.rootWildcard} element={<ErrorRedirect />} />
    </Routes>
  );
}
